import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Right-side detail drawer. Use for document/vehicle detail.
 */
export function Drawer({ open, onClose, title, children, className = '' }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return (
    <>
      <div className="ui-drawer-backdrop" onClick={onClose} aria-hidden="true" />
      <aside className={`ui-drawer ${className}`.trim()} role="dialog" aria-modal="true" aria-label={title}>
        <div className="ui-drawer__header">
          <h2 className="ui-drawer__title">{title}</h2>
          <button type="button" className="ui-drawer__close" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>
        <div className="ui-drawer__body">{children}</div>
      </aside>
    </>
  );
}
